export default __webpack_public_path__ + "static/image8-1baf85296360cd83216f419e5e6c4f59.jpg";